import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Reveal } from './Reveal';
const cardPositions = ['left-[4%] top-[14%] -rotate-12', 'left-[12%] bottom-[12%] rotate-6', 'right-[5%] top-[20%] rotate-12', 'right-[13%] bottom-[10%] -rotate-6'];
export function TarotFrame() {
  const reduce = useReducedMotion();
  return <section className="relative w-full overflow-hidden bg-plum-deep py-16 sm:py-24" data-id="element-152" data-mp="1w7s2ekxk3j7q">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(46,26,71,0.9),#12081c_75%)]" data-id="element-153" data-mp="207j1dbx8l5nc" />
      <div className="absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-ink to-transparent" data-id="element-154" data-mp="2552gsf5o7ogv" />
      <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-ink to-transparent" data-id="element-155" data-mp="29ynfk9f38mh4" />

      {cardPositions.map((pos, i) => <div key={pos} aria-hidden="true" className={`absolute hidden h-44 w-28 rounded-xl border border-gold/30 bg-gradient-to-b from-plum to-plum-deep opacity-70 blur-[3px] shadow-[0_20px_60px_-20px_rgba(0,0,0,0.8)] lg:block ${pos}`} data-id="element-156" data-mp="2jwbaazcp1tza" data-mpi={i}>
          <span className="absolute inset-3 rounded-md border border-gold/20" data-id="element-157" data-mp="849qqrzn2epx" />
          <span className="absolute inset-0 flex items-center justify-center font-serif text-3xl text-gold/50" data-id="element-158" data-mp="3688uady8lg1">
            {['☾', '✶', '☼', '✷'][i]}
          </span>
        </div>)}

      <div className="relative mx-auto flex max-w-6xl flex-col items-center gap-12 px-5 lg:flex-row lg:items-center lg:gap-16" data-id="element-159" data-mp="3pgatkpt0zmym">
        <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-md shrink-0" data-id="element-160" data-mp="qyyiue2akuno">
          <div className="overflow-hidden rounded-[2rem] border border-white/10 shadow-[0_45px_120px_-40px_rgba(0,0,0,0.95)]" data-id="element-161" data-mp="19nbsgtgnmko6">
            <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/92f2dc11-94ca-4e8b-bc84-e1e15b358c81.jpg" alt="Mujer sentada sola en un parque otoñal en actitud reflexiva" className="h-full w-full object-cover" animate={reduce ? undefined : {
            y: [0, -10, 0]
          }} transition={{
            duration: 9,
            repeat: Infinity,
            ease: 'linear'
          }} data-id="element-162" data-mp="14vu372nzu8j1" />
          </div>
          <span aria-hidden="true" className="absolute -inset-3 -z-10 rounded-[2.4rem] bg-gold/10 blur-2xl" data-id="element-163" data-mp="2ubxp1ebl2ag9" />
        </motion.div>

        <div className="max-w-xl text-center lg:text-left" data-id="element-164" data-mp="2kgmaaw06d38i">
          <Reveal data-id="element-165" data-mp="26gbj1ruydmmt">
            <p className="font-sans text-xs font-medium uppercase tracking-[0.35em] text-gold-light/80" data-id="element-166" data-mp="26gv1rasfgf1w">
              El primer paso es hablarlo
            </p>
          </Reveal>
          <Reveal delay={0.1} data-id="element-167" data-mp="4oygh9ggjqtx">
            <h2 className="mt-5 font-serif text-3xl leading-tight text-white sm:text-5xl" data-id="element-168" data-mp="4pq8696xp4ex">
              El silencio prolonga el dolor. La lectura lo nombra.
            </h2>
          </Reveal>
          <Reveal delay={0.2} data-id="element-169" data-mp="1u6vmm37l2bhm">
            <p className="mt-6 font-sans text-base leading-relaxed text-white/70" data-id="element-170" data-mp="1u63oolqik1o6">
              Antes de cualquier trabajo espiritual, escuchamos tu historia y leemos las cartas para
              entender qué energía está bloqueando tu camino amoroso. Solo entonces decidimos juntos
              el ritual adecuado.
            </p>
          </Reveal>
        </div>
      </div>
    </section>;
}